<template>
  <section class="card-recharge-bed">
    <title-bar title="特殊卡年审"
               :isDefaultColor="true">
    </title-bar>
    <div class="info-box">
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_card.png" />

        <div class="select"
             style="margin-top:0px;outline:none;border:1px solid #fff;border-radius:4px;position:relative;">

          <select required
                  class="orderTimeDataSel"
                  v-model="cardType">
            <option value=""
                    disabled
                    selected
                    hidden><span>请选择卡片类型</span>

            </option>
            <option value="513020217">老年卡</option>
            <option value="513020212">学生卡</option>
            <option value="513020216">爱心卡</option>
          </select>
        </div>
        <img src="../assets/img/cardRecharge/icon_down.png"
             class="down" />

        <!-- <input type="text"
               v-model="name"
               placeholder="请输入您的姓名" /> -->
      </div>
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_card.png" />
        <span v-if="!cardType">卡片类型</span>
        <span v-else>{{cardType}}</span>
        <input type="tel"
               v-model="cardNo"
               maxlength="8"
               placeholder="请输入卡号后7位" />
      </div>
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_name.png" />
        <span>姓名</span>
        <input type="tel"
               v-model="name"
               maxlength="16"
               placeholder="请输入持卡人姓名" />
      </div>
      <div class="info-li">
        <img src="../assets/img/cardRecharge/icon_idcard.png" />
        <span>身份证号</span>
        <input type="tel"
               v-model="idcard"
               maxlength="18"
               placeholder="请输入持卡人身份证号" />
      </div>
      <div class="warning">温馨提示：<br />
        1.支持已实名的CPU本地普通卡、CPU本地学生卡在线充值；
        2.充值成功后，需在公交车刷卡机左侧面贴卡2~3秒，完成补登；
        3.确认听到语音提示“补登成功”则充值完成。如未听到此提示，请在同一刷卡机重复补登。</div>
      <div class="btn-box"
           v-if="!cardType">
        <div>提交</div>
      </div>
      <div class="btn-ready"
           v-else
           @click="submit">
        <div>提交</div>
      </div>
    </div>
    <fail-info :isShow="isShow_fail"
               title='年审失败'
               :content='msg'>
      <div @click="readEnd"
           v-show="isShow_fail">确认</div>
    </fail-info>
    <sure-info :isShow="isShow_sure"
               title='提交成功'
               :content='msg_type'>
      <div @click="backHome"
           v-show="isShow_sure"
           v-if="!payFlag">回到首页</div>
      <div @click="goPay"
           v-show="isShow_sure"
           v-else>前往支付</div>
    </sure-info>
  </section>
</template>
<script>
import { goToPay } from '@/api/charge'
import { checkCard, cardReview } from '@/api/list'
import TitleBar from '@/components/TitleBar.vue'
import failInfo from '@/components/failInfo.vue'
import SureInfo from '@/components/SureInfo.vue'





// import Upload from '@/components/Upload.vue'
export default {
  name: 'cardSpecial',
  data () {
    return {
      isGetCard: false,
      imgUrl: '',
      // 姓名
      name: '',
      // 身份证号
      idcard: '',
      cardNo: '',
      numList: [20, 50, 100],
      payNum: 0,
      checked: false,
      cardType: '',
      isShow_fail: false,
      isShow_sure: false,
      msg: '',
      msg_type: '',
      payFlag: false,
      reviewAmount: 0,
      plateOrderId: ''
    }
  },
  computed: {
    // showTitle () {
    //   switch (this.$route.query.type) {
    //     case 'old':
    //       return '敬老卡年审'
    //     case 'stu':
    //       return '学生卡年审'
    //     default:
    //       return ''
    //   }
    // }
  },
  components: { TitleBar, failInfo, SureInfo },
  mounted () {

  },
  methods: {
    // 513020217 老年卡 0217 1003
    // 513020212 学生卡 0212 1003
    // 513020216 爱心卡 0216 1003


    cardArea (cardType) {
      switch (cardType) {
        case '513020217':
          return '1003'
        case '513020212':
          return '1003'
        case '513020216':
          return '1003'
        default:
          return ''
      }

    },
    type (cardType) {
      switch (cardType) {
        case '513020217':
          return '0217'
        case '513020212':
          return '0212'
        case '513020216':
          return '0216'
        default:
          return ''
      }

    },


    goPay () {
      const params = {
        plateOrderId: this.plateOrderId,
        IDCard: this.IDCard,
        balance: '0',
        cardArea: this.cardArea(this.cardType),
        cardNo: this.cardType + '' + this.cardNo,
        name: this.name,
        payPurpose: '04',
        payWay: "80",//根据后台获取支付方式
        phoneNum: JSON.parse(window.sessionStorage.getItem('userInfo')).phoneNum,
        // rechargeAmount: parseFloat(this.amountMoney) * 100,
        rechargeAmount: this.reviewAmount,
        readWay: '01',
        type: this.type(this.cardType),
        tradeType: 'H5',
        redirectUrl: window.location.origin +
          '?phoneNum=' +
          JSON.parse(window.sessionStorage.getItem('userInfo')).phoneNum

      }
      goToPay(params).then(data => {
        if (data.respCode === '01') {
          window.location.href = data.data.payParam
        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: data.respMsg
          })
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })
    },
    selectFlag () {
      this.select = false
    },
    flag () {
      this.checked = !this.checked

    },
    readEnd () {
      this.isShow_fail = false


    },
    choosePay (index) {
      this.payNum = index;
    },
    backHome () {
      this.$router.push({
        name: 'home'
      })
    },
    getImgUrl (img) {
      this.isGetCard = true
      this.imgUrl = img
    },
    returnWord () {
      switch (this.cardType) {
        case '513020217':
          return 'OLD'
        case '513020212':
          return 'STUDENT'
        case '513020216':
          return 'LOVE'
        default:
          return ''
      }

    },
    submit () {

      if (!this.name) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请填写姓名'
        })
        return false
      }
      if (!/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.idcard)) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入合法的身份证号码'
        })
        return false
      }
      if (!/^\d{7}$/.test(this.cardNo)) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入卡号后7位'
        })
        return false
      }
      const params = {
        type: this.returnWord(),
        name: this.name,
        IDCard: this.idcard,
        cardNo: this.cardType + '' + this.cardNo,
      }
      cardReview(params).then(data => {
        if (data.respCode === '01') {
          if (data.data.reviewAmount > 0) {
            this.reviewAmount = data.data.reviewAmount;
            this.plateOrderId = data.data.plateOrderId;
            this.payFlag = true
            this.msg_type = '请先支付年审费' + data.data.reviewAmount / 100 + '元，支付后等待后台审核'
          } else {
            this.msg_type = '年审提交成功，等待后台审核'
          }
          this.isShow_sure = true
        } else {
          this.msg = data.respMsg;
          this.isShow_fail = true
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-recharge-bed {
  height: 100%;
  background: #fff;
}
.info-box {
  margin-top: 16px;
  .orderTimeDataSel {
    height: 40px;
    -webkit-appearance: none;
    appearance: none;
    border: none;
    font-size: 26px;
    padding: 0px 20px;
    display: block;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #ffffff;
    color: #333333;
    border-radius: 4px;
  }
  > .info-li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 32px;
    font-size: 26px;
    font-family: 宋体;
    color: #333333;
    border-bottom: 1px solid #e8ebf0;
    .down {
      width: 14px;
      height: 8px;
    }
    img {
      width: 48px;
      height: 48px;
    }

    span {
      display: inline-block;
      padding: 0 20px;
      width: 180px;
      white-space: nowrap;
      text-align: left;
      // text-align-last: justify;
    }
    input {
      flex: 1;
      border: 0;
      padding-left: 20px;
    }
  }
  > .warning {
    padding: 30px 32px;
    font-size: 22px;
    font-family: 宋体;
    font-weight: 400;
    color: #ef4141;
    text-align: left;
  }
}
.recharge {
  margin-top: 16px;
  width: 100%;
  background-color: #fff;
  padding-bottom: 340px;
  p {
    padding: 24px 32px;
    text-align: left;
    font-size: 30px;
    font-family: 宋体;
    font-weight: 500;
    color: #333333;
  }
  ul {
    width: calc(100% - 64px);
    height: 80px;
    line-height: 80px;
    margin-left: 32px;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    li {
      width: 31%;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #e8ebf0;
      font-size: 30px;
      font-family: 宋体;
      font-weight: 400;
      color: #384253;
    }
    .checked {
      background: #2489ff;
      border: 1px solid #5fbaf3;
      color: #ffffff;
    }
  }
  .pay-type {
    padding: 0px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-type {
      display: flex;
      align-items: center;
    }
    img {
      width: 48px;
      height: 48px;
    }
    .choose {
      width: 40px;
      height: 40px;
    }
    span {
      margin-left: 10px;
    }
    .radio {
      width: 20px;
      height: 20px;
      border: 2px solid rgb(163, 158, 158);
      border-radius: 50%;
    }
  }
}
.btn-box {
  margin: 50px 60px;
  background: #f5f6f8;
  border-radius: 44px 44px 44px 44px;
  padding: 20px 0;
  border-radius: 70px;
  margin-top: 100px;
  font-size: 30px;
  font-family: 宋体;
  font-weight: 400;
  color: #8f98a8;
}
.btn-ready {
  margin: 50px 60px;
  background: #2489ff;
  border-radius: 44px 44px 44px 44px;
  padding: 20px 0;
  border-radius: 70px;
  margin-top: 100px;
  font-size: 30px;
  font-family: 宋体;
  font-weight: 400;
  color: #ffffff;
}
.show-img {
  width: calc(100% - 40px);
  padding: 20px;
  max-height: 100%;
  box-sizing: border-box;
}
input::-webkit-input-placeholder {
  color: #8f98a8;
}
</style>
